<template>
  <div class="cookies-notes" v-if="!isAccepted">
    <div class="cookies-notes--text">We use cookies to enhance your experience. By continuing, you consent to our use of cookies. <nuxt-link to="/privacy-policy">Learn More.</nuxt-link></div>
    <div class="cookies-notes--actions">
      <button class="btn-primary" @click="cookiesAccent">Accept</button>
      <button class="btn-close" @click="cookiesAccent">
        <span class="icon icon-close text-title-1"></span>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const isAccepted = ref(false);
const cookiesAccent = () => {
  localStorage.setItem('GDPR:accepted', 'true')
  isAccepted.value = true
}

onMounted(() => {
  isAccepted.value = localStorage.getItem('GDPR:accepted') ?  localStorage.getItem('GDPR:accepted') === 'true' : false
})
</script>

<style lang="scss" scoped>
.cookies-notes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding: 10px 16px;
  max-width: 1120px;
  margin: 0 auto;
  border: 1px solid #F8F8F8;
  background-color: var(--white);
  backdrop-filter: blur(7.5px);
  box-shadow: 0 2px 4px 0 #16161629;
  border-radius: 6px;
  z-index: 999;
  gap: 16px;

  @media screen and (max-width: 768px) {
    width: auto;
    max-width: 100%;
    left: 15px;
    right: 15px;
    transform: none;
  }

  button.btn-primary {
    background-color: var(--blue);
    height: 36px;
    border-radius: 6px;
    color: var(--white);
    font-size: 14px;
    display: flex;
    gap: 4px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    font-weight: 600;
  }

  .btn-close {
    span {
      font-size: 16px;
    }
  }


  &--text {
    color: #595757;

    a {
      color: var(--blue);
      font-weight: 600;
    }
  }

  &--actions {
    display: flex;
    gap: 12px;
  }
}
</style>
